import React,{ useEffect,useState} from 'react';
import * as kpi from '../../services/kpisServices.js'
import * as app from '../../services/appServices.js'
import "primereact/resources/themes/lara-light-cyan/theme.css";
import ProgressChart from './Charts/ProgressChar.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FormModal from './Modal/Form.jsx';
import Loading from '../../components/loading/Loading.jsx';
import { toast } from 'react-toastify';
import { logout } from '../../redux/actions/login.js';


const Dashboard=()=> {
	const [loading, setLoading] = useState(false);
	const [arrayTabs, setArrayTabs] = useState([]);
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const sessionData=useSelector(state=>state.login);
	const dispatch = useDispatch();
	const [dataQuery, setDataQuery] = useState({
		cycle:sessionData.userData?.cycle,
		stId:sessionData.userData?.commercialStructure, 
		commercialStructureName:sessionData.userData?.commercialStructureName,
		commercialStSelectedId:sessionData.userData?.commercialStSelectedId,
		commercialStSelectedName:sessionData.userData?.commercialStSelectedName
	});
	
	const [modalToggleOptions, setModalToggleOptions] = useState(false);
	const [arrayIndicators, setArrayIndicators] = useState([]);
	const [refreshButton, setRefreshButton] = useState(true);
	const [buttonState, setbuttonState] = useState(false);

	
	useEffect(() => {
		const getSubject =async ()=>{
			try{
				setLoading(true)
				const response = await app.getSubject();
				if(response.status === 200)
				{
					if(response.data.length!==0)
					{
						await getIndicators(response.data[0]?.id);
						setActiveTabIndex(0);
						setArrayTabs(response.data);
					}
				}
				setLoading(false)
			}catch(error){
				setLoading(false);
				// console.log(error);
			}
		}
		getSubject()
	}, [dataQuery,]);

	const getIndicators =async (id)=>{
		
		if(id!=="")
		{
			try{
				setLoading(true)
				const response = await kpi.getIndicatorsSubject(id);
				// console.log('respuesta de Indicadores',response);
				
				
				if(response.status === 200)
					{
						// El backend ya devuelve los indicadores ordenados por DisplayOrder
						// (ver GetIndicatorsBySubjectQuery) — no hace falta reordenar acá.
						setArrayIndicators(response.data.indicators);

					}
					setLoading(false)
				}catch(error){
					setLoading(false);
				}
		}else{
			toast.warning('No se encontro ningun indicador');
		}
	}
	const onChangeRefreshButton =()=>{
		setRefreshButton(!refreshButton);
		setbuttonState(true);
		setTimeout(() => {
			setbuttonState(false);
		}, 60000);
	}
	// useEffect(() => {
	// 	const handleBeforeUnload = (event) => {
	// 	  event.preventDefault();
	// 	  // Custom logic to handle the refresh
	// 	  // Display a confirmation message or perform necessary actions
	// 	};
	// 	window.addEventListener('beforeunload', handleBeforeUnload);
	// 	return () => {
	// 	  window.removeEventListener('beforeunload', handleBeforeUnload);
	// 	};
	//   }, []);

	
	return (<>
		<Loading toggle={loading}/>
		<FormModal toggle={modalToggleOptions} setToggle={(e)=>setModalToggleOptions(e)} dataQuery={dataQuery} setDataQuery={(e)=>setDataQuery({...e})}/>
		<div className='mt-0'>
			<div className="row">
				<div className='col-md-6 col-6'>
				<button  className="btn btn-blue " onClick={()=>setModalToggleOptions(true)}><i className='fas fa-folder-tree fa-fw ' ></i></button>
			</div>
				<div className='col-6 col-md-6'>
				<button  className="btn btn-red btn-circle float-end me-1 ms-1" onClick={()=>dispatch(logout())}><i className='fas fa-door-open fa-fw ' ></i></button>
					{/* <button  className="btn btn-green btn-circle float-end " disabled={buttonState} onClick={()=>onChangeRefreshButton()}><i className='fas fa-sync fa-fw ' ></i></button> */}
					
				</div>
			</div>
			<div className="row">
				<div className='col-md-12 col-12'>
			<ol className="breadcrumb mb-3 ">

				<li className="breadcrumb-item">{dataQuery?.cycle!=="" && dataQuery?.stId!=="" && <>{dataQuery?.cycle}</>}</li>
				<li className="breadcrumb-item">{dataQuery?.commercialStSelectedName!=="" && <>{dataQuery?.commercialStSelectedName}</>}</li>
			</ol>
			</div>
			</div>
			<div className="row ms-0 me-0">
				<div className="col-xl-12">
					<ul className="nav nav-tabs">
						 {arrayTabs.map((tab,index)=>(
							<li className="nav-item " key={tab.id} onClick={()=>{getIndicators(tab.id); setActiveTabIndex(index);}}>
							<a href={`#default-tab-0`} data-bs-toggle="tab" className={`nav-link ${activeTabIndex===index && `active`}`}>
								<span className="d-sm-none">{tab.name} <i className=''></i></span>
								<span className="d-sm-block d-none" >{tab.name}</span>
							</a>
						</li>
						))}
						
					</ul>
					<div className="tab-content panel rounded-0 p-2 m-0">
						<div className="tab-pane fade active show" id="default-tab-0">
							{/* {!loading && */}
								<ProgressChart  dataChart={arrayIndicators} stId={dataQuery?.commercialStSelectedId} cycle={dataQuery.cycle}/>
							{/* }	 */}
						</div>
					</div>
				</div>
			</div>
		</div>
	</>
	)
}

export default Dashboard;